import React from "react";
import TypingSection from "./TypingSection";
import CountUp from "react-countup";
import { useEffect } from "react";
import { useState } from "react";
function StatCard({ value, label }) {
  const isPositive = value.startsWith("+");
  const endValue = parseInt(value.replace("+", ""), 10);
  const [tick, setTick] = useState(0);
  const maxValue = 10000; // Valeur maximale définie pour les valeurs les plus grandes
  const baseDuration = 2; // Durée de base (en secondes)

  // On calcule la durée en fonction du nombre
  const duration = baseDuration * (endValue / maxValue);
  useEffect(() => {
    // lance la première fois au montage
    setTick((t) => t + 1);

    // puis toutes les 15s, on incrémente tick
    const id = setInterval(() => {
      setTick((t) => t + 1);
    }, 5_000);

    return () => clearInterval(id);
  }, []);
  return (
    <div className="bg-white p-6 rounded-lg shadow-sm text-center">
      <div className="text-3xl md:text-4xl font-bold text-blue-600 mb-2">
        <CountUp
          key={tick}
          start={0}
          end={endValue}
          duration={4}
          prefix={isPositive ? "+" : ""}
          separator=" "
        />
      </div>
      <p className="text-gray-600">{label}</p>
    </div>
  );
}

function Testimonial({ quote, author, position, company }) {
  return (
    <div className="bg-white p-8 rounded-lg shadow-sm border border-gray-100">
      <svg
        className="h-8 w-8 text-blue-400 mb-4"
        fill="currentColor"
        viewBox="0 0 32 32"
        aria-hidden="true"
      >
        <path d="M9.352 4C4.456 7.456 1 13.12 1 19.36c0 5.088 3.072 8.064 6.624 8.064 3.36 0 5.856-2.688 5.856-5.856 0-3.168-2.208-5.472-5.088-5.472-.576 0-1.344.096-1.536.192.48-3.264 3.552-7.104 6.624-9.024L9.352 4zm16.512 0c-4.8 3.456-8.256 9.12-8.256 15.36 0 5.088 3.072 8.064 6.624 8.064 3.264 0 5.856-2.688 5.856-5.856 0-3.168-2.304-5.472-5.184-5.472-.576 0-1.248.096-1.44.192.48-3.264 3.456-7.104 6.528-9.024L25.864 4z" />
      </svg>
      <p className="text-gray-600 italic mb-4">{quote}</p>
      <div className="flex items-center">
        <div className="h-10 w-10 rounded-full bg-blue-100 flex items-center justify-center text-blue-600 font-semibold">
          {author.charAt(0)}
        </div>
        <div className="ml-3">
          <p className="text-sm font-medium text-gray-900">{author}</p>
        </div>
      </div>
    </div>
  );
}

export function StatsAndTestimonialsSection() {
  return (
    <section className="py-20 bg-white">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-20">
          <StatCard value="+600" label="Clients" />
          <StatCard value="+30000" label="Candidats inscrits" />
          <StatCard value="44" label="Secteurs d'activité" />
          <StatCard value="+17" label="Années d'experiences" />
        </div>

        <div className="text-center max-w-3xl mx-auto mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            Ce qu'ils disent de nous
          </h2>
          <p className="text-lg text-gray-600">
            Découvrez les témoignages de nos candidats et entreprises
            partenaires
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          <Testimonial
            quote="J'ai entendu beaucoup de bien de cette agence d'intérim de la part de collègues et d'amis, et après avoir travaillé avec eux, je peux confirmer que c'est vraiment au top! L'équipe de recrutement était très professionnelle et ont vraiment pris le temps de comprendre mes compétences et mes préférences en matière d'emploi. Ils m'ont rapidement trouvé un poste qui correspondait à mes besoins et j'ai été impressionné par la rapidité de leur processus de recrutement.

Je recommande vivement !!!"
            author="merco 934"
            position=" "
            company=" "
          />
          <Testimonial
            quote="Professionnalisme et humanisme un couple gagnant !
Je recommande chaleureusement cette agence."
            author="Amèle Morattib"
            position=" "
            company=" "
          />
          <Testimonial
            quote="Agence professionnel et très à l’écoute ! Je ne peux que conseiller. Pour avoir travaillé avec eux, c’est une équipe irréprochable avec un humanisme et un service de qualité !
Je recommande vivement.
Saad."
            author="Samah Elashry"
            position=" "
            company=" "
          />
          <Testimonial
            quote="Si vous cherchez le bon management et des personnes sérieuses et professionnelles J'M intérim est la bonne adresse."
            author="Rajaa FAROUKI"
            position=" "
            company=" "
          />
        </div>
        <div className="text-center max-w-3xl mx-auto mb-16"></div>
      </div>
    </section>
  );
}
